import React, { Component } from "react";
import { Route, Switch, BrowserRouter as Router } from "react-router-dom";

import { ALL_ROUTES } from "../src/global/Constants";

import Splash from "../src/screens/Splash";
import SignIn from "../src/screens/SignIn";
import ForgotPassword from "../src/screens/ForgotPassword";
import Otp from "../src/screens/Otp";
import SetNewPassword from "../src/screens/SetNewPassword";
import LoginWithOTP from "../src/screens/LoginWithOTP";
import HomeToday from "../src/screens/HomeToday";
import AddActivity from "../src/screens/AddActivity";
import AddKrishak from "../src/screens/AddKrishak";
import KrishakInfo from "../src/screens/KrishakInfo";
import SampleToSale from "../src/screens/SampleToSale";
import HarvestDetails from "../src/screens/HarvestDetails";
import ActivityHistory from "../src/screens/ActivityHistory";
import MoreMenu from "../src/screens/MoreMenu";
import MyProfile from '../src/screens/MyProfile';
import Notification from '../src/screens/Notification';
import ChangePassword from '../src/screens/ChangePassword';
import SendFeedback from '../src/screens/SendFeedback';
import ContactUs from '../src/screens/ContactUs';
import AboutTheApp from '../src/screens/AboutTheApp';
import PrivacyPolicy from '../src/screens/PrivacyPolicy';
import RetailerRegistration from '../src/screens/RetailerRegistration';
import VerifyOTP from "./components/VerifyOTP/VerifyOTP";


// Calendar Module
import Calendar from '../src/components/Calendar/Calendar';
import CalendarDay from '../src/screens/CalendarDay';
import CalendarDayFDOSchedule from '../src/screens/CalendarDayFDOSchedule';
import IndividualVisitDetails from '../src/screens/IndividualVisitDetails';
import SampleDistributionDetails from '../src/screens/SampleDistributionDetails';
import GroupMeetingDetailsPage from './components/Calendar/GroupMeetingDetailsPage';
import SampleToSaleDetails from './components/Calendar/SampleToSaleDetails';

// Dashboard Module
import Dashboard from '../src/screens/Dashboard';
import DashboardActivity from "../src/components/Dashboard/DashboardActivity";
import DashboardUsers from "./components/Dashboard/DashboardUsers";
import DashboardTehsils from "./components/Dashboard/DashboardTehsils";

import AddFarmer from './components/Krishak/AddFarmer';
import AddSampleDistribution from './components/Krishak/AddSampleDistribution';
import AddGroupMeeting from './components/Krishak/AddGroupMeeting';
import ManagerFdoDetail from './components/HomeToday/ManagerFdoDetail';

import Reports from './screens/Reports';
import FarmerReport from './components/Reports/FarmerReport';
import IndividualVisitReport from './components/Reports/IndividualVisitReport';
import SampleDistributionReport from './components/Reports/SampleDistributionReport';
import GroupMeetingReport from './components/Reports/GroupMeetingReport';
import SampleToSaleReport from './components/Reports/SampleToSaleReport';
import BulkUploadReport from './components/Reports/BulkUploadReport';
import PrerakReport from "./components/Reports/PrerakReport";
import UserStatusReport from "./components/Reports/UserStatusReport";
import SyncServices from "./providers/SyncServices";

// View Activities
import ActivityDetails from "../src/screens/ActivityDetails";
import GroupMeetingView from "./components/HomeToday/GroupMeetingView";
import SampleToSaleView from './components/HomeToday/SampleToSaleView';

// For Sample To Sale
import ShowingTransplantation from '../src/screens/ShowingTransplantation';
import AddTransplantation from '../src/components/SampleToSale/AddTransplantation';
import FieldDay from '../src/screens/FieldDay';
import PlotVisit from '../src/screens/PlotVisit';
import AddHarvest from "./components/SampleToSale/AddHarvest";
import FieldDamage from "../src/screens/FieldDamage";
import AddGermination from './components/SampleToSale/AddGermination';
import AddFruitQuality from './components/SampleToSale/AddFruitQuality';
import AddPestDisease from './components/SampleToSale/AddPestDisease';
import UserLocationReport from "./components/Reports/UserLocationReport";

//For Activity
import EditSampleDistribution from './components/Activity/EditSampleDistribution';
import EditIndividualVisit from './components/Activity/EditIndividualVisit';
import EditSampleToSale from './components/Activity/EditSampleToSale';
import EditGroupMeeting from "./components/Activity/EditGroupMeeting";

//Daksh Module
import Daksh from './screens/Daksh';
import ViewSalePage from "./components/Daksh/ViewSalePage";
import ViewPlanPage from "./components/Daksh/ViewPlanPage";
import AddSeedworksSale from "./components/Daksh/AddSeedworksSale";
import AddCompetitorSale from "./components/Daksh/AddCompetitorSale";
import DakshApproval from "./components/Daksh/DakshApproval";
import DakshApproveReject from "./components/Daksh/DakshApproveReject";
import SubmitSale from "./components/Daksh/SubmitSale";
import DakshDetails from "./components/Daksh/DakshDetails";

import { toast } from 'react-toastify';


class App extends Component {

  constructor(props) {
    super(props)
    SyncServices.setDatabase();
  }

  componentDidMount() {
    toast.configure();
    navigator.serviceWorker.onerror = function (e) {
      //Utilities.LogPrint('some identifiable string' + e);
      toast.info(e);
    };
  }

  render() {
    return (
      <React.Fragment>
        <Router>
          <Switch>
            {/* Login Modules*/}
            <Route path={ALL_ROUTES.SPLASH_ROUTE} component={Splash} />
            <Route path={ALL_ROUTES.SIGN_IN_ROUTE} component={SignIn} />
            <Route path={ALL_ROUTES.FORGOT_PASSWORD_ROUTE} component={ForgotPassword} />
            <Route path={ALL_ROUTES.OTP_ROUTE} component={Otp} />
            <Route path={ALL_ROUTES.SET_NEW_PASSWORD_ROUTE} component={SetNewPassword} />
            <Route path={ALL_ROUTES.LOGIN_WITH_OTP_ROUTE} component={LoginWithOTP} />
            <Route path={ALL_ROUTES.VERIFY_OTP} component={VerifyOTP} />

            {/* Add Krishak Modules*/}
            <Route path={ALL_ROUTES.ADD_KRISHAK_ROUTE} component={AddKrishak} />
            <Route path={ALL_ROUTES.KRISHAK_INFO_ROUTE} component={KrishakInfo} />

            {/* Home Today Route */}
            <Route path={ALL_ROUTES.HOME_TODAY_ROUTE} component={HomeToday} />
            <Route path={ALL_ROUTES.MANAGER_FDO_DETAIL_ROUTE} component={ManagerFdoDetail} />

            {/* Home Add Activity Route */}
            <Route path={ALL_ROUTES.ADD_ACTIVITY_ROUTE} component={AddActivity} />
            <Route path={ALL_ROUTES.ADD_FARMER_ROUTE} component={AddFarmer} />
            <Route path={ALL_ROUTES.ADD_SAMPLE_DISTRIBUTION_ROUTE} component={AddSampleDistribution} />
            <Route path={ALL_ROUTES.ADD_GROUP_MEET_ROUTE} component={AddGroupMeeting} />

            {/* More Menu Route */}
            <Route path={ALL_ROUTES.MORE_MENU_ROUTE} component={MoreMenu} />
            <Route path={ALL_ROUTES.MY_PROFILE_ROUTE} component={MyProfile} />
            <Route path={ALL_ROUTES.NOTIFICATIONS_ROUTE} component={Notification} />
            <Route path={ALL_ROUTES.CHANGE_PASSWORD_ROUTE} component={ChangePassword} />
            <Route path={ALL_ROUTES.SEND_FEEDBACK_ROUTE} component={SendFeedback} />
            <Route path={ALL_ROUTES.CONTACT_US_ROUTE} component={ContactUs} />
            <Route path={ALL_ROUTES.ABOUT_THE_APP_ROUTE} component={AboutTheApp} />
            <Route path={ALL_ROUTES.PRIVACY_POLICY_ROUTE} component={PrivacyPolicy} />
            <Route path={ALL_ROUTES.RETAILER_REGISTRATION_ROUTE} component={RetailerRegistration} />

            {/* Activity Route */}
            <Route path={ALL_ROUTES.ACTIVITY_DETAILS_ROUTE} component={ActivityDetails} />
            <Route path={ALL_ROUTES.SAMPLE_TO_SALE_VIEW_ROUTE} component={SampleToSaleView} />
            <Route path={ALL_ROUTES.GROUP_MEETING_VIEW_ROUTE} component={GroupMeetingView} />
            <Route path={ALL_ROUTES.EDIT_SAMPLE_DISTRIBUTION_ROUTE} component={EditSampleDistribution} />
            <Route path={ALL_ROUTES.EDIT_INDIVIDUAL_VISIT} component={EditIndividualVisit} />
            <Route path={ALL_ROUTES.EDIT_SAMPLE_TO_SALE} component={EditSampleToSale} />
            <Route path={ALL_ROUTES.EDIT_GROUP_MEETING_ROUTE} component={EditGroupMeeting} />

            {/* Calender Route */}
            <Route path={ALL_ROUTES.CALENDAR_ROUTE} component={Calendar} />
            <Route path={ALL_ROUTES.CALENDAR_DAY_ROUTE} component={CalendarDay} />
            <Route path={ALL_ROUTES.CALENDAR_DAY_FDO_SCHEDULE_ROUTE} component={CalendarDayFDOSchedule} />
            <Route path={ALL_ROUTES.INDIVIDUAL_VISIT_DETAILS_ROUTE} component={IndividualVisitDetails} />
            <Route path={ALL_ROUTES.SAMPLE_DISTRIBUTION_DETAILS_ROUTE} component={SampleDistributionDetails} />
            <Route path={ALL_ROUTES.GROUP_MEETING_DETAILS_ROUTE} component={GroupMeetingDetailsPage} />
            <Route path={ALL_ROUTES.SAMPLE_TO_SALE_DETAILS_ROUTE} component={SampleToSaleDetails} />

            {/* Dashboard Route */}
            <Route path={ALL_ROUTES.DASHBOARD_ROUTE} component={Dashboard} />
            <Route path={ALL_ROUTES.DASHBOARD_ACTIVITIES_ROUTE} component={DashboardActivity} />
            <Route path={ALL_ROUTES.DASHBOARD_USERS_ROUTE} component={DashboardUsers} />
            <Route path={ALL_ROUTES.DASHBOARD_TEHSILS_ROUTE} component={DashboardTehsils} />

            {/* Sample To Sale Route */}
            <Route path={ALL_ROUTES.SAMPLE_TO_SALE_ROUTE} component={SampleToSale} />
            <Route path={ALL_ROUTES.ACTIVITY_HISTORY_ROUTE} component={ActivityHistory} />
            <Route path={ALL_ROUTES.HARVEST_DETAILS_ROUTE} component={HarvestDetails} />
            <Route path={ALL_ROUTES.FIELD_DAMAGE_ROUTE} component={FieldDamage} />
            <Route path={ALL_ROUTES.SHOWING_TRANSPLANTATION_ROUTE} component={ShowingTransplantation} />
            <Route path={ALL_ROUTES.TRANSPLANTATION_ROUTE} component={AddTransplantation} />
            <Route path={ALL_ROUTES.PLOT_VISIT_ROUTE} component={PlotVisit} />
            <Route path={ALL_ROUTES.FIELD_DAY_ROUTE} component={FieldDay} />
            <Route path={ALL_ROUTES.ADD_HARVEST_ROUTE} component={AddHarvest} />
            <Route path={ALL_ROUTES.ADD_GERMINATION_ROUTE} component={AddGermination} />
            <Route path={ALL_ROUTES.ADD_FRUIT_QUALITY_ROUTE} component={AddFruitQuality} />
            <Route path={ALL_ROUTES.ADD_PEST_DISEASE_ROUTE} component={AddPestDisease} />


            {/* Reports Module */}
            <Route path={ALL_ROUTES.REPORTS_ROUTE} component={Reports} />
            <Route path={ALL_ROUTES.FARMER_REPORTS_ROUTE} component={FarmerReport} />
            <Route path={ALL_ROUTES.USER_LOCATION_REPORTS_ROUTE} component={UserLocationReport} />
            <Route path={ALL_ROUTES.INDIVIDUAL_VISIT_REPORTS_ROUTE} component={IndividualVisitReport} />
            <Route path={ALL_ROUTES.SAMPLE_DISTRIBUTION_REPORTS_ROUTE} component={SampleDistributionReport} />
            <Route path={ALL_ROUTES.GROUP_MEETING_REPORTS_ROUTE} component={GroupMeetingReport} />
            <Route path={ALL_ROUTES.SAMPLE_TO_SALE_REPORTS_ROUTE} component={SampleToSaleReport} />
            <Route path={ALL_ROUTES.PRERAK_REPORTS_ROUTE} component={PrerakReport} />
            <Route path={ALL_ROUTES.USER_STATUS_REPORTS_ROUTE} component={UserStatusReport} />
            <Route path={ALL_ROUTES.BULK_UPLOAD_ROUTE} component={BulkUploadReport} />


            {/* Daksh Module */}
            <Route path={ALL_ROUTES.DAKSH_ROUTE} component={Daksh} />
            <Route path={ALL_ROUTES.SALE_DETAILS_ROUTE} component={ViewSalePage} />
            <Route path={ALL_ROUTES.PLAN_DETAILS_ROUTE} component={ViewPlanPage} />
            <Route path={ALL_ROUTES.ADD_SEEDWORKS_SALE} component={AddSeedworksSale} />
            <Route path={ALL_ROUTES.ADD_COMPETITOR_SALE} component={AddCompetitorSale} />
            <Route path={ALL_ROUTES.DAKSH_APPROVAL_ROUTE} component={DakshApproval} />
            <Route path={ALL_ROUTES.DAKSH_APPROVE_REJECT} component={DakshApproveReject} />
            <Route path={ALL_ROUTES.SUBMIT_SALE_ROUTE} component={SubmitSale} />
            <Route path={ALL_ROUTES.DAKSH_DETAILS_ROUTE} component={DakshDetails} />


            {/* Default Module */}
            <Route component={SignIn} />
          </Switch>
        </Router>
      </React.Fragment>
    );
  }
}

export default App;
